export enum CONTENT_EDITOR {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=781979417
     */
    CONFIRM_SWITCH_CONTRIBUTION_MODE_MESSAGE = 'CONTENT_EDITOR.CONFIRM_SWITCH_CONTRIBUTION_MODE_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=781979136
     */
    CONFIRM_SWITCH_DESIGNER_MODE_TITLE = 'CONTENT_EDITOR.CONFIRM_SWITCH_DESIGNER_MODE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=781979587
     */
    CONFIRM_SWITCH_WRITER_MODE_TITLE = 'CONTENT_EDITOR.CONFIRM_SWITCH_WRITER_MODE_TITLE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452682
     */
    CONTENT_SAVE_SUCCESS = 'CONTENT_SAVE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721738373
     */
    CONTENT_SETTINGS_CSS_CLASSES = 'CONTENT_EDITOR.CONTENT_SETTINGS_CSS_CLASSES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=730378626
     */
    CONTENT_SETTINGS_CSS_CLASSES_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_CSS_CLASSES_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721738688
     */
    CONTENT_SETTINGS_CSS_IDENTIFIER = 'CONTENT_EDITOR.CONTENT_SETTINGS_CSS_IDENTIFIER',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452718
     */
    CONTENT_SETTINGS_EDITABLE_BY = 'CONTENT_SETTINGS_EDITABLE_BY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=867514150
     */
    CONTENT_SETTINGS_EDITORS_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_EDITORS_HELPER',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452745
     */
    CONTENT_SETTINGS_EXTERNAL_LINK_HELPER = 'CONTENT_SETTINGS_SLUG_HELP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=728762091
     */
    CONTENT_SETTINGS_FEATURED_CONTENT = 'CONTENT_EDITOR.CONTENT_SETTINGS_FEATURED_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=729082197
     */
    CONTENT_SETTINGS_FEATURED_CONTENT_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_FEATURED_CONTENT_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=730053000
     */
    CONTENT_SETTINGS_HIGHLIGHTED_FOR_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_HIGHLIGHTED_FOR_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=711580949
     */
    CONTENT_SETTINGS_NAVIGATION_LABEL = 'DESIGNER.CONTENT_SETTINGS_NAVIGATION_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=728760974
     */
    CONTENT_SETTINGS_NOTIFY_GROUPS_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_NOTIFY_GROUPS_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721846114
     */
    CONTENT_SETTINGS_NOTIFY_GROUPS_LABEL = 'CONTENT_EDITOR.CONTENT_SETTINGS_NOTIFY_GROUPS_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=730392979
     */
    CONTENT_SETTINGS_SET_AS_HOMEPAGE_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_SET_AS_HOMEPAGE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=763179719
     */
    CONTENT_SETTINGS_SLUG_RESERVED_WORDS = 'CONTENT_EDITOR.CONTENT_SETTINGS_SLUG_RESERVED_WORDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=763179593
     */
    CONTENT_SETTINGS_SLUG_RESTRICTIONS = 'CONTENT_EDITOR.CONTENT_SETTINGS_SLUG_RESTRICTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96021793
     */
    FEATURED_DATE_ENDING_DAY = 'FRONT.EVENT.DIALOG.ENDING_DAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96018596
     */
    FEATURED_DATE_ENDING_HOUR = 'FRONT.EVENT.DIALOG.ENDING_HOUR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96016567
     */
    FEATURED_DATE_STARTING_DAY = 'FRONT.EVENT.DIALOG.STARTING_DAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96021514
     */
    FEATURED_DATE_STARTING_HOUR = 'FRONT.EVENT.DIALOG.STARTING_HOUR',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453642
     */
    INVALID_SLUG = 'SLUG_BAD_FORMAT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=15926594
     */
    URL_ALREADY_EXISTS_ERROR = 'SERVER_ERROR_URL_ALREADY_EXISTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=874636184
     */
    CONTENT_SETTINGS_VISIBLE_BY_ERROR = 'CONTENT_SETTINGS.VISIBLE_BY_ERROR',
}
